import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
// import plugins from './plugins'

Vue.use(Vuex)

export default new Vuex.Store(store)



// WEBPACK FOOTER //
// ./src/store/index.js